export default __webpack_public_path__ + "static/media/4-2_image15@2x.92b4be8b.png";